/* Urban Calm global storefront fixes: Impulse navigation guard + commerce UI labels. */
(function(){
  'use strict';
  document.addEventListener('click',function(event){
    var target=event.target;
    if(!target||!target.closest)return;
    var summary=target.closest('summary');
    if(!summary)return;
    var detail=summary.closest('details');
    if(!detail||detail.getAttribute('data-hover')!=='true')return;
    if(!summary.closest('[data-section-type="header"]'))return;
    if(summary.dataset.link)return;
    event.stopPropagation();
  },true);
})();

(function(){
  'use strict';
  var queuedRoots=[];
  var framePending=false;
  var isHomepage=!!(document.body&&document.body.classList.contains('template-index'));

  function storefrontRoot(){return document.getElementById('PageContainer')||document.body||document;}

  function shortTitle(value){
    value=String(value||'').trim();
    var divider=value.indexOf('|');
    return divider>0?value.slice(0,divider).trim():value;
  }

  function eachMatch(root,selector,callback){
    if(!root)return;
    if(root.nodeType===1&&root.matches&&root.matches(selector))callback(root);
    if(root.querySelectorAll)root.querySelectorAll(selector).forEach(callback);
  }

  function cleanTitles(root){
    eachMatch(root,'.grid-product__title,.product-single__title,.cart__item-name,.uc-cart-upsell__title',function(node){
      var current=node.textContent||'';
      var cleaned=shortTitle(current);
      if(cleaned&&cleaned!==current.trim())node.textContent=cleaned;
    });
  }

  function cleanCart(root){
    eachMatch(root,'.cart__item',function(item){
      var productLink=item.querySelector('.cart__item-name');
      var href=String(productLink&&productLink.getAttribute('href')||'').toLowerCase();
      var singleServe=href.indexOf('kcup')!==-1||href.indexOf('k-cup')!==-1||href.indexOf('pod')!==-1;
      item.querySelectorAll('.cart__item--variants>div').forEach(function(row){
        var label=row.querySelector('span');
        if(!label)return;
        var name=String(label.textContent||'').replace(':','').trim().toLowerCase();
        if(name==='type')label.textContent='Grind:';
        else if(name==='size')label.textContent='Bag size:';
        else if(singleServe&&(name==='quantity'||name==='quanity'))label.textContent='Pack size:';
      });
    });
  }

  function clean(root){cleanTitles(root);cleanCart(root);}

  function flush(){
    framePending=false;
    var roots=queuedRoots.splice(0,queuedRoots.length);
    roots.forEach(clean);
  }

  function queue(root){
    if(!root)return;
    queuedRoots.push(root);
    if(framePending)return;
    framePending=true;
    if(window.requestAnimationFrame)requestAnimationFrame(flush);else setTimeout(flush,0);
  }

  function cleanStorefront(){clean(storefrontRoot());}

  function init(){
    var root=storefrontRoot();
    if(!isHomepage){
      clean(root);
      if(window.MutationObserver&&root&&root.nodeType===1){
        new MutationObserver(function(mutations){
          mutations.forEach(function(mutation){
            mutation.addedNodes.forEach(function(node){
              if(node.nodeType===1)queue(node);
            });
          });
        }).observe(root,{childList:true,subtree:true});
      }
    }
  }

  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',init,{once:true});
  else init();

  document.addEventListener('cart:updated',cleanStorefront);
  document.addEventListener('cart:build',cleanStorefront);
  document.addEventListener('ajaxProduct:added',cleanStorefront);
  document.addEventListener('shopify:section:load',function(event){clean(event.target||storefrontRoot());});
})();
